<!-- FavoriteCell.vue -->
<template>
  <div class="text-center w-100">
    <font-awesome-icon
      @click="onToggle"
      :icon="isFavorite ? ['fas', 'star'] : ['far', 'star']"
      class="cursor-pointer text-warning"
      style="cursor: pointer; font-size: 1.2rem;"
    />
  </div>
</template>

<script>
export default {
  props: {
    // 'row' is the full data object for the row
    row: { type: Object, required: true },
    // 'isFavorite' is the specific value of the favorite field
    isFavorite: { type: [Boolean, Number], default: false },
    // Function prop to bridge the $emit back to parent
    onToggleFavorite: { type: Function, required: true }
  },
  methods: {
    onToggle() {
      // Pass the whole row object back, matching your b-table logic
      this.onToggleFavorite(this.row);
    }
  }
};
</script>

<style scoped>
.text-warning {
  color: #ffc107;
}
</style>
